import { Navbar } from 'bootstrap';

// Navbar
let navDropdown = document.querySelector('.nav-dropdown');
navDropdown.addEventListener('click', () => {
    navDropdown.classList.toggle('show');
})
document.querySelector('body').addEventListener('click', (e) => {
    if(!e.target.closest('.nav-dropdown')){
        navDropdown.classList.remove('show');
    }
});
let btnToggleNav = document.querySelector('.btn-toggle-nav');
let allNavLinks = document.querySelectorAll('.nav-link');
allNavLinks.forEach(navLink => {
    navLink.addEventListener('click', (e) => {
        e.preventDefault();
        // Close Nav
        if(window.innerWidth < 1200){
            btnToggleNav.click();
        }
        let href = navLink.querySelector('a').getAttribute('href');
        if(href !== ''){
            window.location.href = href;
        }
        // Scroll to Section
        let timeout = window.innerWidth < 1200 ? 500 : 0;
        setTimeout(() => {
            let id = navLink.querySelector('a').dataset.id;
            if(document.querySelector(id)){
                window.scrollTo({
                    top: document.querySelector(id).offsetTop - document.querySelector('.navbar').offsetHeight,
                    behavior: 'smooth'
                })
            }
        }, timeout)
        
    })
})